<template v-if="!loading">
    <v-dialog width="700px" v-model="editdialog">
         <v-btn fab dark small color="orange" slot="activator" ><v-icon>edit</v-icon> 
        </v-btn>
        <v-card color="grey lighten-4" flat offset-md4 >
      <v-container grid-list-md pa-3>
            <v-flex xs1 style="float:right">
              <v-btn flat fab small @click="editdialog=false;"> <v-icon>close</v-icon></v-btn>
          </v-flex>
        <v-layout row wrap>
          <v-flex xs12>
            <div style="color: purple; text-align:center;"><h4>Edit the Text</h4></div>
          </v-flex>
        
           <v-flex xs12>
               <v-layout row wrap>
            <v-flex xs6>
        <v-text-field
          name="intPOint"
          label="InterestPoint"
          :value="'interestPoint: '+text.interestPoint"
          readonly
          single-line
        ></v-text-field>
            </v-flex>
              <v-flex xs6>
        <v-text-field
          name="School"
          label="School"
          :value="'School Type: '+ schools[text.infoSchType-1]"
          readonly
          single-line
        ></v-text-field>
            </v-flex>
            </v-layout>
          </v-flex>
          <v-layout row>
          <v-flex xs12>
            <v-text-field 
            name="title" 
            label="Title"
            id="title"
            v-model="edittedTitle"
            maxlength="80"
            required></v-text-field>
          </v-flex>
          </v-layout>
          <v-flex xs12 >
            <v-text-field 
            name="abbreviation" 
            label="Abbreviation"
            id="abbr"
             v-model="editedAbbr"
             maxlength="50"
            required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Period"
               v-model="editedPeriod"
               maxlength="200"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field box multi-line 
            label="Description"
            name="description"
            id="desc"
             v-model="editedDesc"
            required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Source"
                v-model="editedSource"
              required
            ></v-text-field>
          </v-flex>
            <v-flex xs12>
          </v-flex>

      <div style="margin-left:44%;">
            <v-spacer></v-spacer>
          <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
          :disabled="!formIsValid"
          > Edit Text </v-btn>
</div>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
 

</template>

<script>
export default {
  props: {text: Object},
  data () {
    return {
      schools:["Γενικής Παιδείας","Ειδικής Παιδείας"],
      editdialog: false,
      edittedTitle: this.text.infoTTitle,
      editedAbbr: this.text.infoTAbbr,
      editedPeriod: this.text.infoTPeriod,
      editedDesc: this.text.infoTText,
      editedSource:this.text.infoTSource,
      id: this.text.id
    }
  },
  computed: {
     
    formIsValid () {
      return this.edittedTitle !== '' &&
         this.editedDesc !== '';
    },
    loading(){
      return this.$store.getters.loading;
    }
  },
  methods: {
    onSubmitChanges () {
      if (!this.formIsValid) {
        return;
      }
      this.editdialog = false;
      const textData = {
        id: this.id,
        infoTTitle: this.edittedTitle,
        infoTAbbr: this.editedAbbr,
        infoTPeriod: this.editedPeriod,
        infoTText: this.editedDesc,
        infoTSource:this.editedSource,
        lastChangedBy: this.$store.getters.user.email
      };
      this.$store.dispatch('updateText', textData);
      this.$store.dispatch('loadSpotContent', Number(this.$route.params.id));
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/edit/edit.vue